// extracted by mini-css-extract-plugin
export default {"Box":"Sponsor_Box__g5sE9","SponsorBox":"Sponsor_SponsorBox__AYIai","BoxInnerHeader":"Sponsor_BoxInnerHeader__i5Mcb","BoxHeader":"Sponsor_BoxHeader__Quck2"};